const M_WIDTH = 40;
const M_HEIGHT = 40;

const markerStyle = {
    // initially any map object has left top corner at lat lng coordinates
    // it's on you to set object origin to 0,0 coordinates
    position: 'absolute',
    width: M_WIDTH,
    height: M_HEIGHT,
    left: -M_WIDTH / 2,
    top: -M_HEIGHT - 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    color: '#000',
    fontSize: 16,
    fontWeight: 'bold',
};

const clusterMarkerStyle = {
    // initially any map object has left top corner at lat lng coordinates
    // it's on you to set object origin to 0,0 coordinates
    position: 'absolute',
    width: M_WIDTH,
    height: M_HEIGHT,
    left: -M_WIDTH / 2,
    top: -M_HEIGHT - 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    color: '#000',
    fontSize: 16,
    fontWeight: 'bold',
};

export { markerStyle, clusterMarkerStyle };